import { defineStore } from 'pinia'

export const Allerts = defineStore('app_allerts', {
    state: () => {
        return { app_allerts: [] }
    },
    actions: {
        allert(title, text, icon) {
            let element = {
                title: title,
                text: text,
                color: 'deep-orange',
                icon: ['fas', icon]
            }
            this.app_allerts.push(element)

            setTimeout(() => {
                this.app_allerts.pop(element)
            }, 3000)
        },
        warn(title, text, color, icon) {
            let element = {
                title: title,
                text: text,
                color: color,
                icon: ['fas', icon]
            }
            this.app_allerts.push(element)
            setTimeout(() => {
                this.app_allerts.pop(element)
            }, 7000)
        },
        get() {
            return this.app_allerts
        },
        set(value) {
            this.app_allerts = value
        }
    },
})

export const Info = defineStore('app_info', {
    state: () => {
        return { app_info: null }
    },
    actions: {
        warn(title, text, color, type, icon) {
            this.app_info = {
                title: title,
                text: text,
                color: color,
                type: type,
                icon: ['fas', icon]
            }
        },
        get() {
            return this.app_info
        },
        set(value) {
            this.app_info = value
        }
    },
})
